/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createIllustration } from '@atlassian/jira-illustration/src/ui/index.tsx';
import type {
	AsImgProps,
	IllustrationFn,
	SVGViewBox,
} from '@atlassian/jira-illustration/src/ui/types.tsx';
import srcLight from '../../assets/workflow-builder-splash.svg';
import srcDark from '../../assets/workflow-builder-splash-darkmode.svg';

const Illustration: IllustrationFn<AsImgProps> = createIllustration({
	srcLight,
	srcDark,
});

export default Illustration;

// for advanced use only
export const viewBox: SVGViewBox = [0, 0, 42, 48];
